module.exports = __webpack_public_path__ + "img/home_checkin-wait.fbf5ade3.png";